import { DialogProps } from "@mui/material";
import styles from "./styles.module.css";
import { ModalBasic } from "../../../../../../shared/components/ModalBasic";
import { useModalSelectors } from "../../../../../../app/state/modalSlice/hook/use-modal-selectors";
import { AppMarkdownParser } from "../../../../../../shared/components/AppMarkdownParser";
import { useAppSelector } from "../../../../../../services/redux/hooks/use-selector";
import { selectCaseObjectMarkdown } from "../../../../redux/selectors";
import { TModalsIds } from "../../../../../../app/state/modalSlice/types";
import { useTranslation } from "react-i18next";
import { useStorageSelectors } from "../../../../../../app/state/storageObjectSlice/hook/use-storage-selectors";

interface Props extends Omit<DialogProps, "open"> {
  closeModal: (id: TModalsIds) => void;
  className?: string;
}

export const PreviewMarkdownModal = ({ closeModal, className }: Props) => {
  const previewModal = useModalSelectors("preview_markdown_modal");
  const caseMarkdown = useAppSelector(selectCaseObjectMarkdown);
  const { selectedObject } = useStorageSelectors("cases");
  const { t } = useTranslation();

  const handleDownload = () => {
    const fileName = `${selectedObject?.friendly_name || "case"}.md`;

    const blob = new Blob([caseMarkdown], {
      type: "text/markdown;charset=utf-8",
    });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  };

  return (
    <ModalBasic
      open={previewModal.isOpen}
      buttonOkText={t("common.download_file")}
      title={"Проект кейса"}
      onOk={handleDownload}
      onCancel={() => closeModal("preview_markdown_modal")}
      closeModal={() => closeModal("preview_markdown_modal")}
      onClose={() => closeModal("preview_markdown_modal")}
      hasHeader
      hasCloseButton
      hasFooter
    >
      <div className={styles["body"]}>
        <AppMarkdownParser content={caseMarkdown} />
      </div>
    </ModalBasic>
  );
};
